import script from "./WaveAnimation.vue?vue&type=script&setup=true&lang=js"
export * from "./WaveAnimation.vue?vue&type=script&setup=true&lang=js"

import "./WaveAnimation.vue?vue&type=style&index=0&id=5c940890&scoped=true&lang=css"

import exportComponent from "/root/workspace/webFrontEnd_cs-mail-comment_sZq3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c940890"]])

export default __exports__